import React from 'react';
import styled, { css } from 'styled-components';
import { flexRow, palette, breakpoints, flexCenter } from '../../constants/styles';
import Title from './Title';
import Icon from './Icon';
import { Link } from 'react-router-dom';
import { mp } from '../../constants/utils';

const StyledLink = styled(Link)`
  ${flexCenter}
  width: 100%;
`;

const StyledFollowingLinkCTAContainer = styled.div`
  position: fixed;
  z-index: 2000000;
  bottom: 0;
  right: 0;
  height: 50px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  width: fit-content;
  justify-content: flex-end;
  color: white;
  cursor: pointer;
  ${({ opacity }) =>
    opacity &&
    css`
      opacity: ${opacity};
      -webkit-transition: opacity 0.2s ease-in-out;
      -moz-transition: opacity 0.2s ease-in-out;
      -ms-transition: opacity 0.2s ease-in-out;
      -o-transition: opacity 0.2s ease-in-out;
      transition: opacity 0.2s ease-in-out;
      ${opacity === '0' ? 'z-index: -1;' : 'z-index: 2000;'}
    `}
  ${({ marginBottom }) =>
    css`
      margin-bottom: ${marginBottom};
    `}

  ${({ left }) =>
    left &&
    css`
      left: 20px;
      justify-content: flex-start;
      flex-direction: row-reverse;
      ${breakpoints.mobileLandscape} {
        left: 20%;
      }
      ${breakpoints.tablet} {
        left: 25%;
      }
      ${breakpoints.tabletLandscape} {
        left: 30%;
      }
      ${breakpoints.desktop} {
        left: 35%;
      }
    `}
  ${breakpoints.tablet} {
    right: 25%;
  }

  ${({ styles }) => styles}
`;

const StyledCTAPrice = styled.div`
  ${flexRow}
  align-items: center;
  justify-content: flex-end;
  padding: 10px;
  width: fit-content;
  margin-right: -1px;
  background-color: ${palette.secondaryColorShy};
  border-radius: 8px 0px 0px 8px;
  ${({ customColor }) =>
    customColor &&
    css`
      background-color: ${customColor}DD;
    `}
`;

const StyledCTAText = styled.div`
  ${flexRow}
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  width: 100%;
  background-color: ${palette.secondaryColor};
  ${({ customColor }) =>
    customColor &&
    css`
      background-color: ${customColor};
    `}
  border-radius: 8px 8px 8px 8px;
  ${({ CTAPrice }) =>
    CTAPrice &&
    css`
      border-radius: 0px 8px 8px 0px;
    `}
  ${({ border }) =>
    border &&
    css`
      border: ${border};
    `}
`;

const ExternalLink = styled.a`
  ${flexCenter}
  width: 100%;
`;

const FollowingCTA = ({
  CTALink,
  CTAPrice,
  CTAText,
  opacity,
  marginBottom,
  left,
  showArrow,
  customColor,
  referralId = null,
  external = false,
  styles,
  color,
  border,
}) => (
  <StyledFollowingLinkCTAContainer
    styles={styles}
    opacity={opacity}
    marginBottom={marginBottom}
    left={left}
  >
    {!external ? (
      <StyledLink
        style={{ textDecoration: 'none' }}
        to={referralId ? `${CTALink}?referral=${referralId}` : CTALink}
        onClick={() => {
          mp(`FollowingCTA | ${CTAText}`);
        }}
      >
        {CTAPrice && (
          <StyledCTAPrice left={left} customColor={customColor}>
            <Title
              align="center"
              style={{ width: '100%' }}
              level={5}
              color={color ? color : 'white'}
            >
              {CTAPrice}
            </Title>
          </StyledCTAPrice>
        )}
        <StyledCTAText border={border} left={left} CTAPrice={CTAPrice} customColor={customColor}>
          <Title
            align="center"
            style={{ width: '100%' }}
            level={5}
            color={color ? color : 'white'}
            medium
          >
            {CTAText}
          </Title>
          {showArrow && (
            <Icon
              icon="arrowForward"
              color={color ? color : 'white'}
              size={25}
              style={{ marginLeft: '10px' }}
            />
          )}
        </StyledCTAText>
      </StyledLink>
    ) : (
      <ExternalLink
        style={{ textDecoration: 'none' }}
        target="_self"
        href={referralId ? `${CTALink}?referral=${referralId}` : CTALink}
        onClick={() => {
          mp(`FollowingCTA | ${CTAText}`);
        }}
      >
        {CTAPrice && (
          <StyledCTAPrice left={left} customColor={customColor}>
            <Title
              align="center"
              style={{ width: '100%' }}
              level={5}
              color={color ? color : 'white'}
              medium
            >
              {CTAPrice}
            </Title>
          </StyledCTAPrice>
        )}
        <StyledCTAText border={border} left={left} CTAPrice={CTAPrice} customColor={customColor}>
          <Title
            align="center"
            style={{ width: '100%' }}
            level={5}
            color={color ? color : 'white'}
            medium
          >
            {CTAText}
          </Title>
          {showArrow && (
            <Icon
              icon="arrowForward"
              color={color ? color : 'white'}
              size={25}
              style={{ marginLeft: '10px' }}
            />
          )}
        </StyledCTAText>
      </ExternalLink>
    )}
  </StyledFollowingLinkCTAContainer>
);

export default FollowingCTA;
